import { render } from "./MoList.vue?vue&type=template&id=02385332"
import script from "./MoList.vue?vue&type=script&lang=ts"
export * from "./MoList.vue?vue&type=script&lang=ts"
script.render = render

export default script